import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ScallopProps {
    direction?: 'up' | 'down'
    className?: string
}

// Wavy edge for a section. Place it inside a `relative` section and give it the
// section's background as a text color, for example `text-cream`.
// `up` sits on the section's top edge, `down` hangs from its bottom edge.
export const Scallop: FC<ScallopProps> = ({ direction = 'up', className }): ReactNode => {
    return (
        <div
            aria-hidden='true'
            className={cn(
                'scallop-wave pointer-events-none absolute inset-x-0 z-10',
                direction === 'up' ? 'scallop-up bottom-[calc(100%-1px)]' : 'scallop-down top-[calc(100%-1px)]',
                className
            )}
        />
    )
}
